/* eslint-disable space-before-function-paren */
import native from '@zz-common/native-adapter/es/all'
import { cookie, isEmptyData } from '@zz-yp/hunter-js-utils'
import { setCookie } from './helper'
import { miniInterceptor } from './miniAuth'

export const login = () => {
  return new Promise((resolve) => {
    return native.login({
      isHunter: true,
      callback: (res) => {
        resolve(res)
      }
    })
  })
}

export const logout = (obj = {}) => {
  return new Promise((resolve) => {
    /**
     * 特别提示:
     *    WKWebview是异步存储cookie，iOS上有个时间差（iOS业界难题）
     *    所以先调sdk的clearLoginStatus方法清除客户端的登陆状态，再在回调函数里再去清除cookie
     *
     * 支持版本: iOS >= 1.7.1, Android >= 1.0.0
     */
    native.wrap('clearLoginStatus')({ ...obj }, (res) => {
      setCookie('PPU', '')
      setCookie('uid', '')
      resolve(res)
    })
  })
}

export const reLogin = async (cb) => {
  const interceptRes = await miniInterceptor()
  if (!interceptRes) return false // mini 取消登录

  await logout()

  const res = await login()
  cb && cb(res)
}

// 获取登录状态
export const getLoginStatus = () => {
  return !isEmptyData(cookie.getPPU())
}

// 控制页面登录状态
export const needLogin = async function () {
  const loginStatus = getLoginStatus()
  if (loginStatus) return true

  const interceptRes = await miniInterceptor()
  if (!interceptRes) return false // mini 取消登录

  const res = await login()
  return res && res.code == 0
}
